import React, { useState, createContext } from "react";

const MessageDraftContext = createContext({ draft: null, setDraft: () => {} });

const MessageDraftProvider = ({ children }) => {
  const [draft, setDraft] = useState(null);
  return (
    <MessageDraftContext.Provider value={{ draft, setDraft }}>
      {children}
    </MessageDraftContext.Provider>
  );
};

export { MessageDraftContext, MessageDraftProvider };
